import { combineReducers } from "redux";
import { accountsReducer } from "./accountsReducer";
import { usersReducer } from "./usersReducer";

import { invitationsReducer } from "./invitationsReducer";
import { streamsReducer } from "./streamsReducer";
import { collectionsReducer } from "./collectionsReducer";
import { assetsReducer } from "./assetsReducer";
import { sharesReducer } from "./sharesReducer";
import { reportsReducer } from "./reportsReducer";
import { userGroupsReducer } from "./userGroupReducer";
import { iadbReducer } from "./iadbReducer";
import { cleverstoryWorkspaceReducer } from "./cleverstoryWorkspaceReducer";
import { cleverstoryDomainsReducer } from "./cleverstoryDomainsReducer";
import { datasourceReducer } from "./datasourceReducer";

import { LOGOUT_COGNITO_USER } from "constants/actionTypes";
import AuthService from "services/auth.service";
import { auditLogsReducer } from "./auditLogsReducer";
import { adoptionMetricsReducer } from "./adoptionMetricsReducer";

import { downloadsReducer } from "./downloadsReducer";
import { downloadInvoiceReducer } from "reducers/downloadInvoiceReducer";
import { generateReportReducer } from "./generateReportReducer";
import { dataSourceInspector } from "./dataSourceInspectorReducer";
import { assetManagementReducer } from "./assetManagementReducer";
import { metricsReducer } from "./metricsReducer";

const appReducer = combineReducers({
  users: usersReducer,
  accounts: accountsReducer,
  invitations: invitationsReducer,
  streams: streamsReducer,
  collections: collectionsReducer,
  assets: assetsReducer,
  shares: sharesReducer,
  reports: reportsReducer,
  userGroups: userGroupsReducer,
  iadb: iadbReducer,
  cleverstoryWorkspace: cleverstoryWorkspaceReducer,
  cleverstoryDomains: cleverstoryDomainsReducer,
  auditLogs: auditLogsReducer,
  adoptionMetrics: adoptionMetricsReducer,
  downloads: downloadsReducer,
  datasources: datasourceReducer,
  downloadInvoice: downloadInvoiceReducer,
  generateReports: generateReportReducer,
  dataSourceInspector: dataSourceInspector,
  accountAssetTransactions: assetManagementReducer,
  metrics: metricsReducer
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_COGNITO_USER) {
    state = undefined;
    AuthService.clearAccessToken();
  }

  return appReducer(state, action);
};

export default rootReducer;
